import './instrument'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
// Axios
import axios from 'axios'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import 'nouislider/dist/nouislider.css'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider, setupAxios } from './app/modules/auth'
import { ThemeModeProvider } from './_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { BrandSplashScreen, ModalProvider, ToastProvider } from './app/components'
import { MetronicSplashScreenProvider } from './_metronic/layout/core'
import { ErroInesperado } from './app/modules/errors/components/ErroInesperado'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    // Último recurso, fora do Router e dos providers: por isso a tela usa link comum, não <Link>.
    <Sentry.ErrorBoundary
      fallback={({ error, eventId }) => <ErroInesperado error={error} eventId={eventId} />}
    >
      <QueryClientProvider client={queryClient}>
        <MetronicSplashScreenProvider splash={<BrandSplashScreen />}>
          <MetronicI18nProvider>
            <ThemeModeProvider>
              <AuthProvider>
                <ModalProvider>
                  <ToastProvider>
                    <AppRoutes />
                  </ToastProvider>
                </ModalProvider>
              </AuthProvider>
            </ThemeModeProvider>
          </MetronicI18nProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </MetronicSplashScreenProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}
